module.exports = __webpack_public_path__ + "static/media/hierarquia.28e97397.png";